import { render, staticRenderFns } from "./ReadAloud.vue?vue&type=template&id=1581883f&scoped=true"
import script from "./ReadAloud.vue?vue&type=script&lang=ts"
export * from "./ReadAloud.vue?vue&type=script&lang=ts"
import style0 from "./ReadAloud.vue?vue&type=style&index=0&id=1581883f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1581883f",
  null
  
)

export default component.exports